import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import "./Acquisition.css";
import { useEnterprise } from "../../context/EnterpriseContext";

// Export of the company_name variable to be used by other components
export let company_name = "";

// List of business activity sectors
const ACTIVITY_SECTORS = [
  "Agriculture, forestry and fishing",
  "Mining and quarrying",
  "Manufacturing industry",
  "Electricity, gas production and distribution",
  "Water production and distribution, sanitation",
  "Construction",
  "Trade, repair of motor vehicles and motorcycles",
  "Transport and storage",
  "Accommodation and food service activities",
  "Information and communication",
  "Financial and insurance activities",
  "Real estate activities",
  "Professional, scientific and technical activities",
  "Administrative and support service activities",
  "Public administration",
  "Education",
  "Human health and social work",
  "Arts, entertainment and recreation",
  "Other service activities",
  "Activities of households as employers",
  "Extraterritorial activities"
];

function Acquisition(props) {
  const {
    companyName,
    inputPlaceholder1,
    companySize,
    inputPlaceholder2,
    activitySector,
    inputPlaceholder3,
    measuringForm,
  } = props;

  const {
    companyName: contextCompanyName,
    setCompanyName,
    companySize: contextCompanySize,
    setCompanySize,
    activitySector: contextActivitySector,
    setActivitySector,
    saveEnterpriseData
  } = useEnterprise();

  const [companyNameValue, setCompanyNameValue] = useState(contextCompanyName || "");
  const [companySizeValue, setCompanySizeValue] = useState(contextCompanySize || "");
  const [activitySectorValue, setActivitySectorValue] = useState(contextActivitySector || "");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const history = useHistory();

  // ✅ Form validation
  function validateForm() {
    if (!companyNameValue.trim()) {
      setError("The company name is required");
      return false;
    }

    if (!companySizeValue || isNaN(companySizeValue) || companySizeValue <= 0) {
      setError("The company size must be a positive number");
      return false;
    }

    if (!activitySectorValue.trim()) {
      setError("The activity sector is required");
      return false;
    }

    return true;
  }

  // ✅ Main save function
  async function updateDataFromInput() {
    setError("");
    setSuccess("");

    if (!validateForm()) {
      return;
    }

    setCompanyName(companyNameValue);
    setCompanySize(parseInt(companySizeValue, 10));
    setActivitySector(activitySectorValue);

    company_name = companyNameValue; // global export

    const data = {
      company_name: companyNameValue,
      company_size: parseInt(companySizeValue, 10),
      activity_sector: activitySectorValue,
    };

    setIsLoading(true);

    try {
      // Call through the Enterprise context
      const result = await saveEnterpriseData(data);
      console.log("📥 Result of saveEnterpriseData:", result);

      if (result.success) {
        setSuccess("✅ Data saved successfully!");
        localStorage.setItem("enterprise_id", result.enterpriseId);

        // Redirect to the form after 1s
        setTimeout(() => {
          history.push("/measuring-form");
        }, 1000);
      } else {
        throw new Error(result.error || "Error while saving the data");
      }
    } catch (error) {
      console.error("❌ Save error:", error);
      setError(error.message || "Error while saving. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }

  // Navigation
  function navigateToMeasuringForm() {
    history.push("/measuring-form");
  }

  function navigateToHome() {
    history.push("/home");
  }

  return (
    <div className="acquisition-container">
      <div className="acquisition-content">
        <h1 className="acquisition-title">Company Information</h1>

        {error && <div className="error-message">❌ {error}</div>}
        {success && <div className="success-message">{success}</div>}

        <div className="acquisition-form">
          {/* Name field */}
          <div className="form-group">
            <label htmlFor="companyName">{companyName || "Company Name"}</label>
            <input
              id="companyName"
              className="form-input"
              name="companyName"
              placeholder={inputPlaceholder1 || "Enter company name"}
              type="text"
              value={companyNameValue}
              onChange={(e) => setCompanyNameValue(e.target.value)}
              required
            />
          </div>

          {/* Size field */}
          <div className="form-group">
            <label htmlFor="companySize">{companySize || "Company Size"}</label>
            <input
              id="companySize"
              className="form-input"
              name="companySize"
              placeholder={inputPlaceholder2 || "Enter number of employees"}
              type="number"
              value={companySizeValue}
              onChange={(e) => setCompanySizeValue(e.target.value)}
              required
            />
          </div>

          {/* Sector field */}
          <div className="form-group">
            <label htmlFor="activitySector">{activitySector || "Activity Sector"}</label>
            <select
              id="activitySector"
              className="form-select"
              name="activitySector"
              value={activitySectorValue}
              onChange={(e) => setActivitySectorValue(e.target.value)}
              required
            >
              <option value="" disabled>
                Select an activity sector
              </option>
              {ACTIVITY_SECTORS.map((sector, index) => (
                <option key={index} value={sector}>
                  {sector}
                </option>
              ))}
            </select>
          </div>

          {/* Buttons */}
          <div className="form-actions">
            <button
              onClick={updateDataFromInput}
              className="btn-primary"
              disabled={isLoading}
            >
              {isLoading ? "⏳ Saving..." : "💾 Save Data"}
            </button>

            <button
              onClick={navigateToMeasuringForm}
              className="btn-secondary"
            >
              {measuringForm || "➡️ Continue to Measuring Form"}
            </button>

            <button
              onClick={navigateToHome}
              className="btn-tertiary"
            >
              ⬅️ Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Acquisition;
